import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { X } from 'lucide-react';

const SESSION_KEY = 'nli_banner_dismissed';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SaleBanner() {
  const [banner, setBanner] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    axios.get(`${API}/settings/banner`).then(res => {
      if (res.data?.enabled) {
        setBanner(res.data);
        setVisible(true);
      }
    }).catch(() => {});
  }, []);

  if (!visible || !banner) return null;

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(SESSION_KEY, '1');
  };

  const inner = (
    <div
      className="relative flex items-center justify-center gap-3 px-10 py-2.5 text-sm font-semibold"
      style={{ backgroundColor: banner.bg_color, color: banner.text_color }}
    >
      <span>{banner.message}</span>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); dismiss(); }}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-0.5 opacity-70 hover:opacity-100 transition-opacity"
        aria-label="Dismiss banner"
        style={{ color: banner.text_color }}
      >
        <X size={15} />
      </button>
    </div>
  );

  if (banner.link) {
    return (
      <Link to={banner.link} className="block hover:opacity-95 transition-opacity" onClick={() => dismiss()}>
        {inner}
      </Link>
    );
  }

  return <div>{inner}</div>;
}
